import {userGuard} from '~/router/middleware/guards'
import OperatorsQuality from '~/components/pages/stat/operators/OperatorsQuality'
import OperatorsQualityProjects from '~/components/pages/stat/operators/OperatorsQualityProjects'
import OperatorsMatrix from '~/components/pages/stat/operators/OperatorsMatrix'
import OperatorsTimeline from '~/components/pages/stat/operators/OperatorsTimeline'
import OperatorsEmployment from '~/components/pages/stat/operators/OperatorsEmployment'
import OperatorsIgnore from '~/components/pages/stat/operators/OperatorsIgnore'
import DurationTalkByOperators from '~/components/pages/stat/DurationTalkByOperators'
import OperatorsByProjects from '~/components/pages/stat/operators/OperatorsByProjects'

export default [
    {
        path: '/stat/operators/report',
        name: 'operators.report',
        component: OperatorsQuality,
        middleware: {
            permissions: ['statiz.transcribe-search.report']
        },
        beforeEnter: userGuard
    },
    {
        path: '/stat/operators/report/projects/:uid',
        name: 'OperatorsQualityProjects',
        component: OperatorsQualityProjects,
        middleware: {
            permissions: ['statiz.transcribe-search.report']
        },
        beforeEnter: userGuard
    },
    {
        path: '/stat/OperatorsMatrix',
        name: 'operators.matrix',
        component: OperatorsMatrix,
        middleware: {
            permissions: ['statiz.transcribe-search.report'],
        },
        beforeEnter: userGuard
    },
    {
        path: '/stat/OperatorsTimeline',
        name: 'operators.timeline',
        component: OperatorsTimeline,
        middleware: {
            permissions: ['statiz.transcribe-search.report'],
        },
        beforeEnter: userGuard
    },
    {
        path: '/stat/OperatorsEmployment',
        name: 'operators.employment',
        component: OperatorsEmployment,
        middleware: {
            permissions: ['statiz.transcribe-search.report'],
        },
        beforeEnter: userGuard
    },
    {
        path: '/stat/OperatorsIgnore',
        name: 'operators.ignores',
        component: OperatorsIgnore,
        middleware: {
            permissions: ['statiz.transcribe-search.report'],
        },
        beforeEnter: userGuard
    },
    {
        path: '/stat/DurationTalkByOperators',
        name: 'duration-talk-by-operators',
        component: DurationTalkByOperators,
        middleware: {
            permissions: ['statiz.duration-talk.report'],
        },
        beforeEnter: userGuard
    },
    {
        path: '/stat/OperatorsByProjects',
        name: 'operators-by-projects',
        component: OperatorsByProjects,
        middleware: {
            permissions: ['statiz.operators-by-projects'],
        },
        beforeEnter: userGuard
    },
]